import { memo } from 'react'
import { Box, Stack, Typography } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import { EmptyStateAction, GhostFigure } from '../common/EmptyState'

type Props = {
    /** The text that was searched for, already trimmed. */
    query: string
    /** Present when a category filter narrowed the search; clicking it searches every category. */
    onSearchAllCategories?: () => void
}

/** "No matches" state for the symbol search. A miss is not an invitation, so no ghost rows here. */
const SearchNoResults = ({ query, onSearchAllCategories }: Props) => (
    <Stack className="empty-view" justifyContent="center" alignItems="center" sx={{ px: 3, textAlign: 'center' }}>
        <Box sx={{ mb: 3 }}>
            <GhostFigure variant="search" />
        </Box>
        <Typography variant="subtitle1" sx={{ fontWeight: 'medium' }}>
            {query ? (
                <>
                    No matches for &ldquo;{query}&rdquo;
                </>
            ) : (
                'No symbols in this category'
            )}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.75, maxWidth: 320 }}>
            {onSearchAllCategories ? 'Check the spelling, or search across every category.' : 'Check the spelling, or try another name.'}
        </Typography>
        {onSearchAllCategories && (
            <Box sx={{ width: 240, mt: 2 }}>
                <EmptyStateAction
                    label="Search all categories"
                    icon={<SearchIcon sx={{ fontSize: 16 }} />}
                    onClick={onSearchAllCategories}
                />
            </Box>
        )}
    </Stack>
)

export default memo(SearchNoResults)
